import { render, staticRenderFns } from "./StandConfigFurnitureForm.vue?vue&type=template&id=4fe7d8ce&scoped=true&"
import script from "./StandConfigFurnitureForm.vue?vue&type=script&lang=js&"
export * from "./StandConfigFurnitureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe7d8ce",
  null
  
)

export default component.exports